import { DateConverter } from 'src/app/core/services/mapper/converters';

export class EngagementCtOc {
    static jsonMap = {
        dateDerniereMajInventaire: { key: 'dateDerniereMajInventaire', converter: new DateConverter(), optional: true },
        idAuteur: { key: 'idAuteur', optional: true },
        nomPrenomAuteur: { key: 'nomPrenomAuteur', optional: true, default: '' },
        surfaceTotale: { key: 'surfaceTotale', optional: true },
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' },
        typeEntreprise: { key: 'typeEntreprise', optional: true, default: '' },
        idEntreprise: { key: 'idEntreprise', optional: true }
    };

    public dateDerniereMajInventaire: moment.Moment;
    public idAuteur: number = undefined;
    public nomPrenomAuteur: string = undefined;
    public surfaceTotale: number = undefined;
    public raisonSociale: string = undefined;
    public typeEntreprise: string = undefined;
    public idEntreprise: number = undefined;

    public dateEngagement: moment.Moment = undefined;
    public conseillerTechnique: string = undefined;
}
